import { useSession } from "next-auth/react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOrganization } from "@/lib/api-calls/organizations/get-organization";
import { updateOrganization } from "@/lib/api-calls/organizations/update-organization";
import {
  setOrganization,
  setOrganizationLoading,
  setOrganizationError,
  updateOrganizationName,
} from "@/stores/organizations-store/organizations-reducer";
import {
  selectCurrentOrganization,
  selectOrganizationLoading,
  selectOrganizationError,
} from "@/stores/organizations-store/organizations-selectors";

export function useOrganization() {
  const { data: session } = useSession();
  const dispatch = useDispatch();
  const organization = useSelector(selectCurrentOrganization);
  const isLoading = useSelector(selectOrganizationLoading);
  const error = useSelector(selectOrganizationError);

  useEffect(() => {
    async function fetchOrganization() {
      if (!session?.userId) {
        return;
      }

      dispatch(setOrganizationLoading(true));
      try {
        const data = await getOrganization();
        dispatch(setOrganization(data));
      } catch (err) {
        dispatch(
          setOrganizationError(
            err instanceof Error ? err.message : "Unknown error",
          ),
        );
      }
    }

    fetchOrganization();
  }, [session?.userId, dispatch]);

  const updateOrgName = async (name: string) => {
    if (!organization) return;

    try {
      const updatedOrg = await updateOrganization(name);
      dispatch(updateOrganizationName(name));
      return updatedOrg;
    } catch (err) {
      dispatch(
        setOrganizationError(
          err instanceof Error ? err.message : "Failed to update organization",
        ),
      );
      throw err;
    }
  };

  return { organization, isLoading, error, updateOrgName };
}
